import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from '@klarna/bubble-ui';
import { formUtils } from 'moet-core';

export const MultiSelectDropdown = ({
  label,
  addValue,
  disabled = false,
  options = [],
  value = [],
  ...props
}) => {
  const mappedOptions = formUtils
    .addEmptyDropdownItem(
      options.map(({ key, label }) => ({
        key,
        label,
        disabled: value.includes(key),
      })),
    )
    .sort(({ label: a = '' }, { label: b = '' }) => a.localeCompare(b));

  return (
    <Dropdown
      {...props}
      disabled={disabled}
      label={label}
      options={mappedOptions}
      onChange={addValue}
      value=""
    />
  );
};

MultiSelectDropdown.propTypes = {
  addValue: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  options: PropTypes.PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ),
  value: PropTypes.array,
};
